/* ============================================================
   IMENHOF BLOOM — Gedeeld bezorgdatum-systeem
   Eén bron voor de levertijdberekening, gebruikt door zowel het
   levertijdblok op de productpagina (snippets/imenhof-levertijd.liquid)
   als de bezorgweek-kiezer in de winkelwagen (assets/bezorgweek.js).
   Zo lopen de getoonde data nooit uit elkaar.

   Zones (vanaf besteldatum):
     - std (grootste deel van NL): 3 tot 8 werkdagen
     - far (Zeeland en Limburg):   7 tot 14 kalenderdagen, van weekend afgeschoven
   ============================================================ */
(function () {
  'use strict';
  var WD = ['zo', 'ma', 'di', 'wo', 'do', 'vr', 'za'];
  var MO = ['jan', 'feb', 'mrt', 'apr', 'mei', 'jun', 'jul', 'aug', 'sep', 'okt', 'nov', 'dec'];

  function work(base, n) {
    var d = new Date(base); var a = 0;
    while (a < n) { d.setDate(d.getDate() + 1); var g = d.getDay(); if (g !== 0 && g !== 6) a++; }
    return d;
  }
  function cal(base, n) {
    var d = new Date(base); d.setDate(d.getDate() + n);
    var g = d.getDay(); if (g === 6) d.setDate(d.getDate() + 2); else if (g === 0) d.setDate(d.getDate() + 1);
    return d;
  }
  function fmt(d) { return WD[d.getDay()] + ' ' + d.getDate() + ' ' + MO[d.getMonth()]; }
  function today() { var t = new Date(); t.setHours(0, 0, 0, 0); return t; }
  function stdWindow(base) { base = base || today(); return { start: work(base, 3), end: work(base, 8) }; }
  function farWindow(base) { base = base || today(); return { start: cal(base, 7), end: cal(base, 14) }; }
  function windowText(zone, base) {
    var w = (zone === 'far') ? farWindow(base) : stdWindow(base);
    return 'in huis tussen ' + fmt(w.start) + ' en ' + fmt(w.end);
  }

  window.ImhLevertijd = {
    WD: WD, MO: MO,
    work: work, cal: cal, fmt: fmt, today: today,
    stdWindow: stdWindow, farWindow: farWindow, windowText: windowText
  };
})();

/* ============================================================
   Loader — Advies & service in zoeken/FAQ (additief)
   Dit bestand wordt globaal en met defer geladen, dus het is een
   veilige plek voor een kleine loader. Laadt assets/imh-help-search.js
   alleen op de zoekresultatenpagina en de FAQ-pagina. De asset-URL
   wordt afgeleid van de eigen <script>-src, zodat hier geen Liquid
   nodig is en layout/theme.liquid ongemoeid blijft.
   ============================================================ */
(function () {
  try {
    var onSearch = document.body && (document.body.classList.contains('template-search') || /\/search\/?$/.test(location.pathname));
    var onFaq = !!document.querySelector('.fb-q');
    if (!onSearch && !onFaq) return;
    var me = document.currentScript;
    if (!me || !me.src) return;
    var base = me.src.split('?')[0].replace(/[^\/]*$/, '');
    var s = document.createElement('script');
    s.src = base + 'imh-help-search.js';
    s.defer = true;
    (document.head || document.documentElement).appendChild(s);
  } catch (e) {}
})();
